import { useEffect, useState } from "react";
import Breadcrumb from "../../../../component/Breadcrumb";
import { Link, useParams } from "react-router-dom";
import { Pagination } from "../../../../component/Common/pagination";
import { getContextReport } from "../../../../redux/feature/translation/context/getContextReportSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../component/Common/Loader";

export const ReportContextFileById = () => {
  const ITEM_PER_PAGE = 10;
  const dispatch = useDispatch();
  const { id } = useParams();
  const responseUrlData = useSelector((state) => state.getContextReport);

  const [currentPage, setCurrentPage] = useState(1);
  const [sampleData, setSampleData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [totalPage, setTotalPage] = useState(null);

  useEffect(() => {
    const request = { contextRequestId: id };
    dispatch(getContextReport(request));
  }, [id, dispatch]);

  useEffect(() => {
    if (responseUrlData.data.length > 0) {
      const data = responseUrlData.data[0].result.value.map((obj) => ({
        contextId: obj.context_id,
        urlDataId: obj.url_data_id,
        entryId: obj.entry_id,
        contentType: obj.content_type,
        title: obj.title,
        url: obj.root_url,
      }));
      setSampleData(data);
      setTotalPage(Math.ceil(data.length / ITEM_PER_PAGE));
    }
  }, [responseUrlData]);

  useEffect(() => {
    const start = (currentPage - 1) * ITEM_PER_PAGE;
    const end = start + ITEM_PER_PAGE;
    setPaginatedData(sampleData.slice(start, end));
  }, [currentPage, sampleData]);

  const onPageChange = (index) => {
    setCurrentPage(index);
  };

  return (
    <div className="dashboard-ecommerce">
      <div className="container-fluid dashboard-content">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <Breadcrumb />
            <div className="widget">
              <div className="card-header">URL Data</div>
              <hr className="hr" />
              <div className="p-2" />
              <div className="mx-4">
                <div className="table-responsive">
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr className="text-black text-red">
                        <th scope="col">Context ID</th>
                        <th scope="col">URL Data ID</th>
                        <th scope="col">Entry Id</th>
                        <th scope="col">Content Type</th>
                        <th scope="col">Name/Title</th>
                        <th scope="col">URL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {responseUrlData.loading ? (
                        <Loader />
                      ) : (
                        paginatedData.map((data) => (
                          <tr key={data.urlDataId}>
                            <td>{data.contextId}</td>
                            <td>{data.urlDataId}</td>
                            <td>{data.entryId}</td>
                            <td>{data.contentType}</td>
                            <td>{data.title}</td>
                            <td>
                              <Link
                                className="report-link"
                                to={data.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {data.url}
                              </Link>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  currentPage={currentPage}
                  onPageChange={onPageChange}
                  totalPage={totalPage}
                  itemPerPage={10}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
